"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="payment-preview-page">
        
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2>${'route.payment.preview'.t()}</h2>
            <div>
                <button class="btn btn-outline-secondary me-2" @click="${x => x.refreshPayment()}" ?disabled="${x => x.loading}">
                    <i class="fas fa-sync-alt"></i> ${'common.refresh'.t()}
                </button>
                <button class="btn btn-primary" @click="${x => x.goBack()}">
                    <i class="fas fa-arrow-left"></i> ${'common.back'.t()}
                </button>
            </div>
        </div>
        
        <div class="text-center" ?hidden="${x => !x.loading}">
            <app-loader></app-loader>
            <p class="mt-3">${'common.loading'.t()}</p>
        </div>

        
        <div class="alert alert-danger" ?hidden="${x => !x.error}">
            <i class="fas fa-exclamation-triangle me-2"></i>
            ${x => x.error}
        </div>

        
        <div ?hidden="${x => x.loading || x.error || !x.payment}">
            <div class="row">
                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">${'payment.details'.t()}</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                
                                <div class="col-md-6 mb-3">
                                    <label class="form-label text-muted">${'payment.id'.t()}</label>
                                    <div class="fw-bold">${x => { var _a; return ((_a = x.payment) === null || _a === void 0 ? void 0 : _a.id) || '-'; }}</div>
                                </div>

                                
                                <div class="col-md-6 mb-3">
                                    <label class="form-label text-muted">${'payment.sessionId'.t()}</label>
                                    <div class="fw-bold">${x => { var _a; return ((_a = x.payment) === null || _a === void 0 ? void 0 : _a.sessionId) || '-'; }}</div>
                                </div>

                                
                                <div class="col-md-6 mb-3">
                                    <label class="form-label text-muted">${'payment.provider'.t()}</label>
                                    <div>
                                        <span class="badge badge-${x => { var _a; return x.getProviderBadgeClass((_a = x.payment) === null || _a === void 0 ? void 0 : _a.provider); }}">
                                            ${x => { var _a; return x.getProviderDisplayName((_a = x.payment) === null || _a === void 0 ? void 0 : _a.provider); }}
                                        </span>
                                    </div>
                                </div>

                                
                                <div class="col-md-6 mb-3">
                                    <label class="form-label text-muted">${'payment.status'.t()}</label>
                                    <div>
                                        <span class="badge badge-${x => { var _a; return x.getStatusBadgeClass((_a = x.payment) === null || _a === void 0 ? void 0 : _a.status); }}">
                                            ${x => { var _a; return x.getStatusDisplayName((_a = x.payment) === null || _a === void 0 ? void 0 : _a.status); }}
                                        </span>
                                    </div>
                                </div>

                                
                                <div class="col-md-6 mb-3">
                                    <label class="form-label text-muted">${'payment.amount'.t()}</label>
                                    <div class="fw-bold text-success">
                                        ${x => { var _a, _b; return x.formatAmount((_a = x.payment) === null || _a === void 0 ? void 0 : _a.amount, (_b = x.payment) === null || _b === void 0 ? void 0 : _b.currency); }}
                                    </div>
                                </div>

                                
                                <div class="col-md-6 mb-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.targetAccountGrade); }}">
                                    <label class="form-label text-muted">${'payment.targetGrade'.t()}</label>
                                    <div class="fw-bold">${x => { var _a, _b; return ((_b = (_a = x.payment) === null || _a === void 0 ? void 0 : _a.targetAccountGrade) === null || _b === void 0 ? void 0 : _b.name) || '-'; }}</div>
                                </div>

                                
                                <div class="col-12 mb-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.description); }}">
                                    <label class="form-label text-muted">${'payment.description'.t()}</label>
                                    <div>${x => { var _a; return ((_a = x.payment) === null || _a === void 0 ? void 0 : _a.description) || '-'; }}</div>
                                </div>

                                
                                <div class="col-md-6 mb-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.email); }}">
                                    <label class="form-label text-muted">${'payment.email'.t()}</label>
                                    <div>${x => { var _a; return ((_a = x.payment) === null || _a === void 0 ? void 0 : _a.email) || '-'; }}</div>
                                </div>

                                
                                <div class="col-md-6 mb-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.user); }}">
                                    <label class="form-label text-muted">${'payment.user'.t()}</label>
                                    <div>${x => { var _a, _b, _c, _d; return ((_b = (_a = x.payment) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.name) || ((_d = (_c = x.payment) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.username) || '-'; }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    
                    <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">${'payment.timeline'.t()}</h5>
                        </div>
                        <div class="card-body">
                            <div class="timeline">
                                
                                <div class="timeline-item">
                                    <div class="timeline-marker bg-secondary"></div>
                                    <div class="timeline-content">
                                        <h6 class="mb-1">${'payment.created'.t()}</h6>
                                        <p class="text-muted mb-0">
                                            ${x => { var _a; return x.formatDate((_a = x.payment) === null || _a === void 0 ? void 0 : _a.createdAt); }}
                                        </p>
                                    </div>
                                </div>

                                
                                <div class="timeline-item" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.updatedAt); }}">
                                    <div class="timeline-marker bg-info"></div>
                                    <div class="timeline-content">
                                        <h6 class="mb-1">${'payment.updated'.t()}</h6>
                                        <p class="text-muted mb-0">
                                            ${x => { var _a; return x.formatDate((_a = x.payment) === null || _a === void 0 ? void 0 : _a.updatedAt); }}
                                        </p>
                                    </div>
                                </div>

                                
                                <div class="timeline-item" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.paidAt); }}">
                                    <div class="timeline-marker bg-success"></div>
                                    <div class="timeline-content">
                                        <h6 class="mb-1">${'payment.paidAt'.t()}</h6>
                                        <p class="text-muted mb-0">
                                            ${x => { var _a; return x.formatDate((_a = x.payment) === null || _a === void 0 ? void 0 : _a.paidAt); }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="card mt-3" ?hidden="${x => { var _a, _b, _c; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.stripePaymentIntentId) && !((_b = x.payment) === null || _b === void 0 ? void 0 : _b.stripeCustomerId) && !((_c = x.payment) === null || _c === void 0 ? void 0 : _c.orderId); }}">
                        <div class="card-header">
                            <h5 class="mb-0">${'payment.technicalDetails'.t()}</h5>
                        </div>
                        <div class="card-body">
                            
                            <div class="mb-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.stripePaymentIntentId); }}">
                                <label class="form-label text-muted">${'payment.stripePaymentIntentId'.t()}</label>
                                <div class="font-monospace small">${x => { var _a; return (_a = x.payment) === null || _a === void 0 ? void 0 : _a.stripePaymentIntentId; }}</div>
                            </div>

                            
                            <div class="mb-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.stripeCustomerId); }}">
                                <label class="form-label text-muted">${'payment.stripeCustomerId'.t()}</label>
                                <div class="font-monospace small">${x => { var _a; return (_a = x.payment) === null || _a === void 0 ? void 0 : _a.stripeCustomerId; }}</div>
                            </div>

                            
                            <div class="mb-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.orderId); }}">
                                <label class="form-label text-muted">${'payment.orderId'.t()}</label>
                                <div>${x => { var _a; return (_a = x.payment) === null || _a === void 0 ? void 0 : _a.orderId; }}</div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="card mt-3" ?hidden="${x => { var _a; return !((_a = x.payment) === null || _a === void 0 ? void 0 : _a.failureReason); }}">
                        <div class="card-header">
                            <h5 class="mb-0 text-danger">${'payment.failureReason'.t()}</h5>
                        </div>
                        <div class="card-body">
                            <div class="text-danger">
                                ${x => { var _a; return (_a = x.payment) === null || _a === void 0 ? void 0 : _a.failureReason; }}
                            </div>
                        </div>
                    </div>

                    
                    <div class="card mt-3" ?hidden="${x => !x.getMetadata()}">
                        <div class="card-header">
                            <h5 class="mb-0">${'payment.metadata'.t()}</h5>
                        </div>
                        <div class="card-body">
                            <pre class="small text-muted">${x => JSON.stringify(x.getMetadata(), null, 2)}</pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.payment-preview-page .timeline {
  position: relative;
}
.payment-preview-page .timeline::before {
  content: "";
  position: absolute;
  left: 9px;
  top: 20px;
  bottom: 0;
  width: 2px;
  background-color: #e0e0e0;
}
.payment-preview-page .timeline .timeline-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  position: relative;
}
.payment-preview-page .timeline .timeline-item:last-child {
  margin-bottom: 0;
}
.payment-preview-page .timeline .timeline-item:last-child::after {
  content: "";
  position: absolute;
  left: 8px;
  bottom: -10px;
  width: 4px;
  height: 10px;
  background-color: white;
}
.payment-preview-page .timeline .timeline-item .timeline-marker {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  border: 2px solid white;
  box-shadow: 0 0 0 1px #e0e0e0;
}
.payment-preview-page .timeline .timeline-item .timeline-content {
  flex: 1;
  padding-top: 2px;
}
.payment-preview-page .timeline .timeline-item .timeline-content h6 {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  color: #495057;
}
.payment-preview-page .timeline .timeline-item .timeline-content p {
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 0;
}
.payment-preview-page .card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.payment-preview-page .card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 7px 7px 0 0;
}
.payment-preview-page .card .card-header h5 {
  font-weight: 600;
  color: #495057;
}
.payment-preview-page .form-label {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.payment-preview-page .fw-bold {
  font-weight: 600 !important;
}
.payment-preview-page .font-monospace {
  font-family: "Courier New", monospace;
  word-break: break-all;
}
.payment-preview-page .badge {
  font-size: 0.75rem;
  padding: 0.375em 0.75em;
}
.payment-preview-page pre {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 0.75rem;
  margin-bottom: 0;
  max-height: 200px;
  overflow-y: auto;
}

.timeline-marker.bg-secondary {
  background-color: #6c757d !important;
}
.timeline-marker.bg-info {
  background-color: #17a2b8 !important;
}
.timeline-marker.bg-success {
  background-color: #28a745 !important;
}

@media (max-width: 768px) {
  .payment-preview-page .d-flex.justify-content-between {
    flex-direction: column;
    align-items: flex-start;
  }
  .payment-preview-page .d-flex.justify-content-between .btn-group {
    margin-top: 1rem;
    width: 100%;
  }
  .payment-preview-page .timeline::before {
    left: 8px;
  }
  .payment-preview-page .timeline .timeline-item .timeline-marker {
    width: 16px;
    height: 16px;
    margin-right: 12px;
  }
}`;
const shadowOptions = { "mode": "open" };
let PaymentPreview = class PaymentPreview extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.payment = null;
        this.error = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Get payment ID from route params
        const routeParams = this.routeParams;
        if (routeParams.id) {
            this.paymentId = routeParams.id;
            await this.loadPayment();
        }
        else {
            this.error = 'payment.preview.errors.noId'.t();
            this.loading = false;
        }
    }
    async loadPayment() {
        if (!this.paymentId)
            return;
        this.loading = true;
        this.error = null;
        try {
            const response = await this.apiService.back.get('payment.status', {
                routeParams: { id: this.paymentId }
            });
            if (response && response.success && response.data) {
                this.payment = response.data;
            }
            else {
                this.error = (response === null || response === void 0 ? void 0 : response.error) || 'payment.preview.errors.loadFailed'.t();
            }
        }
        catch (e) {
            console.error('Failed to load payment:', e);
            this.error = 'payment.preview.errors.loadFailed'.t();
        }
        finally {
            this.loading = false;
        }
    }
    formatAmount(amount, currency) {
        if (!amount && amount !== 0)
            return '-';
        // Convert cents to dollars
        const displayAmount = (amount / 100).toFixed(2);
        return `$${displayAmount} ${currency || 'USD'}`;
    }
    formatDate(dateString) {
        if (!dateString)
            return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    }
    getStatusDisplayName(status) {
        switch (status) {
            case backendImport_1.PaymentStatus.PENDING:
                return 'payment.status.pending'.t();
            case backendImport_1.PaymentStatus.SUCCESS:
                return 'payment.status.success'.t();
            case backendImport_1.PaymentStatus.REJECTED:
                return 'payment.status.rejected'.t();
            case backendImport_1.PaymentStatus.ERROR:
                return 'payment.status.error'.t();
            default:
                return 'payment.status.unknown'.t();
        }
    }
    getStatusBadgeClass(status) {
        switch (status) {
            case backendImport_1.PaymentStatus.PENDING:
                return 'warning';
            case backendImport_1.PaymentStatus.SUCCESS:
                return 'success';
            case backendImport_1.PaymentStatus.REJECTED:
            case backendImport_1.PaymentStatus.ERROR:
                return 'danger';
            default:
                return 'secondary';
        }
    }
    getProviderDisplayName(provider) {
        switch (provider) {
            case backendImport_1.PaymentProvider.STRIPE:
                return 'Stripe';
            case backendImport_1.PaymentProvider.PAYPAL:
                return 'PayPal';
            default:
                return provider;
        }
    }
    getProviderBadgeClass(provider) {
        switch (provider) {
            case backendImport_1.PaymentProvider.STRIPE:
                return 'primary';
            case backendImport_1.PaymentProvider.PAYPAL:
                return 'info';
            default:
                return 'secondary';
        }
    }
    getMetadata() {
        var _a;
        if (!((_a = this.payment) === null || _a === void 0 ? void 0 : _a.metadata))
            return null;
        try {
            return JSON.parse(this.payment.metadata);
        }
        catch (e) {
            return null;
        }
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/payment/list');
    }
    async refreshPayment() {
        await this.loadPayment();
        this.notifyService.notify('payment.preview.refreshed'.t(), 'info');
    }
};
exports.PaymentPreview = PaymentPreview;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaymentPreview.prototype, "paymentId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PaymentPreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IPayment !== "undefined" && backendImport_1.IPayment) === "function" ? _a : Object)
], PaymentPreview.prototype, "payment", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentPreview.prototype, "error", void 0);
exports.PaymentPreview = PaymentPreview = __decorate([
    (0, client_1.RWSView)('payment-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], PaymentPreview);
PaymentPreview.defineComponent();
